module.exports = __webpack_public_path__ + "static/media/women-channel-bar.577a162f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/testActivity/women-channel-bar.gif
// module id = 1867
// module chunks = 6